/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// Put here shared constants

// ---------------------------
// Api Root
// ---------------------------
export const API_ROOT = process.env.API || '';

export const AVAILABILITY_ALERT_BASE_PATH = '/availabilitynotification';
// Availability alerts timed entry
export const AVAILABILITY_ALERT_TIMED_ENTRY = 'timedentry';
